import React, { useEffect, useState } from "react";

import unicornImg from "@/assets/yay-unicorn.webp";

const UNICORN_URL = unicornImg;
const EVENT = "inspire:yay";
const SOUND_KEY = "inspire.yaySound";

export const isYaySoundOn = () => localStorage.getItem(SOUND_KEY) !== "off";
export const setYaySoundOn = (on) => localStorage.setItem(SOUND_KEY, on ? "on" : "off");

export const playTwinkle = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = new Ctx();
  const notes = [1046.5, 1318.5, 1568, 2093, 2637, 3136];
  notes.forEach((f, i) => {
    const t = ctx.currentTime + i * 0.08;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "triangle";
    osc.frequency.value = f;
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.18, t + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t);
    osc.stop(t + 0.55);
  });
  setTimeout(() => ctx.close(), 1400);
};

export const celebrate = () => {
  window.dispatchEvent(new Event(EVENT));
  if (isYaySoundOn()) playTwinkle();
};

export const YayCelebration = () => {
  const [run, setRun] = useState(0);

  useEffect(() => {
    const img = new Image();
    img.src = UNICORN_URL;
    img.decode?.().catch(() => {});
    const onYay = () => setRun((n) => n + 1);
    window.addEventListener(EVENT, onYay);
    return () => window.removeEventListener(EVENT, onYay);
  }, []);

  useEffect(() => {
    if (!run) return;
    const t = setTimeout(() => setRun(0), 2000);
    return () => clearTimeout(t);
  }, [run]);

  // Keep a decoded copy in the DOM so the popup paints instantly.
  if (!run) return <img src={UNICORN_URL} alt="" aria-hidden="true" className="fixed w-px h-px opacity-0 pointer-events-none -z-10" />;
  return (
    <div
      key={run}
      className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none yay-backdrop"
      data-testid="yay-celebration"
    >
      <div className="yay-card flex flex-col items-center">
        <img
          src={UNICORN_URL}
          alt="Unicorn flying with a rainbow"
          className="yay-unicorn w-72 sm:w-96 h-auto select-none"
          decoding="sync"
          draggable={false}
        />
        <p
          className="yay-text text-7xl sm:text-8xl font-black drop-shadow-lg tracking-tight bg-gradient-to-r from-pink-500 via-amber-400 to-sky-500 bg-clip-text text-transparent"
          data-testid="yay-celebration-text"
        >
          YAY!
        </p>
      </div>
    </div>
  );
};

export default YayCelebration;
